export const MONTHS_NAME = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto',
    'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
export const MONTHS_SHORT_NAME = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

const DATE = {
    DAYS: Array.from(Array(31), (x, y) =>
        ({id: `0${y + 1}`.slice(-2), value: `${y + 1}`})),
    MONTHS: Array.from(Array(12), (x, y) =>
        ({id: `0${y + 1}`.slice(-2), value: `${MONTHS_SHORT_NAME[y]}`})),
    YEARS: (minYear: number, rangeYears: number = 60) => {
        const years = [];
        const d = new Date();
        const currentYear = d.getFullYear() - minYear;
        for (let i = currentYear; i > currentYear - rangeYears; i -= 1) {
            years.push({id: `${i}`, value: `${i}`});
        }
        return years;
    },
    HOURS: (rangeHours:number = 24) => {
        return Array.from(Array(rangeHours), (x, y) =>
            ({id: `0${y + 1}`.slice(-2), value: `${(`0${y + 1}`).slice(-2)}`}));
    },
    MINUTES: (intervalMinutes:number = 30) => {
        const minutes = [];
        const zero = '0';
        for (let i = 0; i < 60; i += intervalMinutes) {
            const min = `${(zero + i).slice(-2)}`;
            minutes.push({id: min, value: min});
        }
        return minutes;
    }
};

const LABEL = {
    DATE_FORMAT_SPLIT: '-',
    TIME_FORMAT_SPLIT: ':',
    DATE_FORMAT_SPLIT_CREDIT_CARD: '/',
    FORMAT_DATE: 'dd-MM-yyyy',
    LABEL_TODAY: 'Hoy'
};

export {
    DATE,
    LABEL
};